import { ICartItems } from "../../../Interfaces/Cart";
import { formatMoney } from "../../../Utils/Money";
import { Choice } from "./Choice";

export const SELECTORS = {
    PRICE: ":scope span.price"
};

export abstract class ProductFlow extends Choice {
    protected constructor(templateId: string, eventContinue: string, cartItems: ICartItems) {
        super("template#cart-flow-header", "template#cart-flow-tabs", templateId, eventContinue);
        this.cartItems = cartItems;
    }

    /**
     * obtain header from template
     */
    protected initHeader(): this {
        super.initHeader().header.querySelector<HTMLSpanElement>(SELECTORS.PRICE).innerHTML = formatMoney(
            this.cartItems.items[0].final_price,
            this.headerTemplate.dataset.moneyFormat
        );
        return this;
    }
}
